import loadFontOperation from 'editor/src/store/fonts/operation/loadFontOperation';
import getFontDefinition from 'editor/src/store/fonts/selector/getFontDefinition';
import isFontFileLoaded from 'editor/src/store/fonts/utils/isFontFileLoaded';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import type { RootState } from 'editor/src/store/index';

/**
 * Makes sure a style's font can be measured before texts are re-laid out in it.
 * Resolves false when the font failed to load, so the caller leaves the texts alone
 * rather than sizing their boxes with a fallback font.
 */
const loadTextStyleFontOperation =
  (fontFile: string) =>
  async (dispatch: ThunkDispatch, getState: () => RootState): Promise<boolean> => {
    if (isFontFileLoaded(fontFile)) {
      return true;
    }
    // Protected uploaded fonts have no file: they render server side, like with the font picker.
    const fontDefinition = getFontDefinition(getState(), fontFile);
    if (fontDefinition?.isUploaded && !fontDefinition.metadata.fileUrl) {
      return true;
    }
    await dispatch(loadFontOperation(fontFile));
    return isFontFileLoaded(fontFile);
  };

export default loadTextStyleFontOperation;
